/*! Wi-forms - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

$.fn.selectpicker.Constructor.DEFAULTS.iconBase = 'fa';
$.fn.selectpicker.Constructor.DEFAULTS.tickIcon = 'fa-check';
$.fn.selectpicker.Constructor.DEFAULTS.liveSearch = 'TRUE';

+function ($) {
    'use strict';
    var wiForms = window.wiForms;
    window.wiForms = {

        init: function () {
            wiForms.contact.init();
            wiForms.download.init();
            wiForms.newsletter.init();
            wiForms.login.init();
            wiForms.register.init();
            wiForms.search.init();
            wiForms.gmap.init();
            wiForms.chainedState.init();
        },
        chainedState: {
            init: function () {
                if ($('.select-state').length && $('.select-country').length) {
                    $('.select-state').each(function () {
                        var $state   = $(this);
                        var parent   = $state.attr('data-parent');
                        $state.remoteChained({
                            parents: parent,
                            url: urls.site + 'api/forms/update_states?lang_id=' + language_id
                        });
                        $state.on('change', function () {
                            $state.selectpicker('refresh');
                        });
                        $(parent).trigger('change');
                    });
                }
            }
        },
        contact: {
            init: function () {
                if ($('#contact_form').length) {
                    $('#submit_contact').addClass('disabled');
                    $('#submit_contact').prop('disabled', true);
                    $('.tlw').attr('title', lang['form_timeout']);
                    setTimeout(function () {
                        $('#submit_contact').removeClass('disabled');
                        $('#submit_contact').prop('disabled', false);
                        $('.tlw').attr('data-original-title', lang['form_timeout_send']);
                    }, 10000);
                    wiForms.contact.send();
                }
            },
            send: function () {
                $('#submit_contact').on('click', function (e) {
                    e.preventDefault();
                    wiLayout.loader('show');
                    var form_data = $('#contact_form').serialize();
                    var lang_id = language_id;
                    $.ajax({
                        url: '/module/forms/send/contact/' + lang_id,
                        type: 'POST',
                        data: form_data,
                        success: function (data) {
                            if (data.status === 'success') {
                                $('#contact_validation').remove();
                                $(data.data).insertBefore('#contact_form');
                                $('#contact_form')[0].reset();
                                wiLayout.scroll.to('#contact_validation');
                            } else {
                                $('#contact_validation').remove();
                                $(data.data).insertBefore('#contact_form');
                                wiLayout.scroll.to('#contact_validation');
                            }
                            wiLayout.loader('remove');
                        }
                    });
                });
            }

        },
        newsletter: {
            init: function () {
                if ($('#newsletter_form').length) {
                    wiForms.newsletter.send();
                }
            },
            send: function () {
                $(document).on('submit', '#newsletter_form', function (e) {
                    e.preventDefault();
                    wiLayout.loader('show');
                    var th = $(this);
                    th.prop("disabled", true);
                    var form_data = th.serialize();
                    var lang_id = language_id;
                    $.ajax({
                        url: '/module/forms/send/newsletter/' + lang_id,
                        type: 'POST',
                        data: form_data,
                        success: function (data) {
                            if (data.status === 'success') {
                                $('#newsletter_validation').remove();
                                $(data.data).insertBefore(th);
                                th[0].reset();
                                wiLayout.scroll.to('#newsletter_validation');
                            } else {
                                $('#newsletter_validation').remove();
                                $(data.data).insertBefore(th);
                                wiLayout.scroll.to('#newsletter_validation');
                            }
                            wiLayout.loader('remove');
                            th.prop("disabled", false);
                        }
                    });
                });
            }

        },
        download: {
            init: function () {
                if ($('#download_form').length) {
                    wiForms.download.send();
                }
            },
            send: function () {
                $('#submit_download').on('click', function (e) {
                    e.preventDefault();
                    wiLayout.loader('show');
                    var form_data = $('#download_form').serialize();
                    var lang_id = language_id;
                    $.ajax({
                        url: '/module/forms/send/download/' + lang_id,
                        type: 'POST',
                        data: form_data,
                        success: function (data) {
                            if (data.status === 'success') {
                                $('#download_validation').remove();
                                $(data.data).insertBefore('#download_form');
                                $('#download_form')[0].reset();
                                wiLayout.scroll.to('#download_validation');
                            } else {
                                $('#download_validation').remove();
                                $(data.data).insertBefore('#download_form');
                                wiLayout.scroll.to('#download_validation');
                            }
                            wiLayout.loader('remove');
                        }
                    });
                });
            }
        },
        login: {
            init: function () {
                if ($('#login_form').length) {
                    wiForms.login.send();
                }
            },
            send: function () {
                $('#submit_login').on('click', function (e) {
                    e.preventDefault();
                    wiLayout.loader('show');
                    var th = $(this);
                    th.prop("disabled", true);
                    var form_data = $('#login_form').serialize();
                    var lang_id = language_id;
                    $.ajax({
                        url: '/module/forms/login/' + lang_id,
                        type: 'POST',
                        data: form_data,
                        success: function (data) {
                            if (data.status === 'success') {
                                $('#login_validation').remove();
                                $(data.data).insertBefore('#login_form');
                                $('#login_form')[0].reset();
                                var redirect = $('#login_form input[name=\"redirect\"]').val();
                                location.href = redirect;
                            } else {
                                $('#login_validation').remove();
                                $(data.data).insertBefore('#login_form');
                                wiLayout.scroll.to('#login_validation');
                            }
                            wiLayout.loader('remove');
                            th.prop("disabled", false);
                        }
                    });
                });
            }
        },
        register: {
            init: function () {
                if ($('#register_form').length) {
                    wiForms.download.send();
                }
            },
            send: function () {
                $('#submit_login').on('click', function (e) {
                    e.preventDefault();
                    wiLayout.loader('show');
                    var th = $(this);
                    th.prop("disabled", true);
                    var form_data = $('#register_form').serialize();
                    var lang_id = language_id;
                    $.ajax({
                        url: '/module/forms/register/' + lang_id,
                        type: 'POST',
                        data: form_data,
                        success: function (data) {
                            if (data.status === 'success') {
                                $('#register_validation').remove();
                                $(data.data).insertBefore('#register_form');
                                $('#register_form')[0].reset();
                                var redirect = $('#register_form input[name=\"redirect\"]').val();
                                location.href = redirect;
                            } else {
                                $('#register_validation').remove();
                                $(data.data).insertBefore('#register_form');
                                wiLayout.scroll.to('#register_validation');
                            }
                            wiLayout.loader('remove');
                            th.prop("disabled", false);
                        }
                    });
                });
            }
        },
        gmap: {
            init: function () {
                wiForms.gmap.search.init();
            },
            search: {
                init: function () {
                    if ($('#search_gmap_form').length) {
                        wiForms.gmap.search.send();
                    }
                },
                send: function () {
                    $('#search_gmap_form').on('change', function (e) {
                        e.preventDefault();
                        wiLayout.loader('show');
                        var th = $(this);
                        var form_data = th.serialize();
                        var lang_id = language_id;
                        $.ajax({
                            url: '/module/gmap/search/' + lang_id,
                            type: 'POST',
                            data: form_data,
                            success: function (data) {
                                if (data.status === 'success') {
                                    $('.gmap-ajax').html(data.html);
                                    wiLayout.scroll.to('#map_' + data.id);
                                    wi.layout.gmap.load(data.id);
                                }
                                wiLayout.loader('remove');
                            }
                        });
                    });
                }
            }
        },
        search: {
            init: function () {
                wiForms.search.products.init();
            },
            products: {
                init: function () {
                    if ($('.products-search-form').length) {
                        $('.products-search-form').each(function () {
                            var th = $(this);
                            var search = th.data('search');
                            if (search === 'true') {
                                th.trigger('submit');
                            }
                        });
                        wiForms.search.products.send();
                    }
                },
                send: function () {
                    $('.products-search-form').on('submit', function (e) {
                        e.preventDefault();
                        wiLayout.loader('show');
                        var th = $(this);
                        var form_data = th.serialize();
                        var lang_id = language_id;
                        $.ajax({
                            url: '/module/products_search/search/' + lang_id,
                            type: 'POST',
                            data: form_data,
                            success: function (data) {
                                if (data.status === 'success') {
                                    $('#products_search_validation').remove();
                                    $(data.validation).insertBefore(th);
                                    $('.products-search-result').html(data.html);
                                    wiLayout.scroll.to('.products-search-result');
                                    $(window).trigger('resize');
                                } else {
                                    $('#products_search_validation').remove();
                                    $(data.validation).insertBefore(th);
                                    wiLayout.scroll.to('#search_validation');
                                }
                                wiLayout.loader('remove');
                            }
                        });
                    });
                }
            }
        }
    };
    $(function () {
        wiForms = window.wiForms;
        wiForms.init();
    });
}(jQuery);
